import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Component from './ItemDetails';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, selectedItem, error, message,
  } = state.box;
  return {
    isLoading,
    selectedItem,
    error,
    message,
  };
}

const Styled = withStyles(styles)(Component);

export default connect(
  mapStateToProps,
)(Styled);
